document.addEventListener("DOMContentLoaded", () => {
	const solutionsRadio = document.querySelector(".solutionsRadio");

	if (!solutionsRadio) {
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				loadSolutionsRadioLottie(entry.target);
				observer.unobserve(entry.target);
			}
		});
	});

	document.querySelectorAll(".signalLottieContainer").forEach((container) => {
		observer.observe(container);
	});

	// Start typing animation when the prompts area enters the viewport
	const promptsWrapper = solutionsRadio.querySelector(".solutionsRadio__agent-prompts-wrapper");

	const sectionObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					initAgentTyping(solutionsRadio);
					sectionObserver.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.2 }
	);

	if (promptsWrapper) {
		sectionObserver.observe(promptsWrapper);
	} else {
		initAgentTyping(solutionsRadio);
	}
});

function loadSolutionsRadioLottie(container) {
	const animationPath = container.dataset.animationPath;

	if (animationPath) {
		const animation = window.lottie.loadAnimation({
			container: container,
			renderer: "svg",
			loop: true,
			autoplay: true,
			path: animationPath,
		});

		animation.addEventListener("config_ready", () => {
			animation.play();
		});
	}
}

function initAgentTyping(rootEl) {
	const items = Array.from(rootEl.querySelectorAll(".solutionsRadio__agent-prompts-text"));

	if (!items.length) {
		return;
	}

	// Prepare items: store original content and clear
	items.forEach((el) => {
		el.dataset.original = (el.textContent || "").trim();
		el.classList.remove("active");
		el.textContent = "";
	});

	let index = 0;

	const typeNext = () => {
		const current = items[index];
		const text = current.dataset.original || "";

		typeTextInElement(current, text, 40, 1600, () => {
			current.classList.remove("active");
			current.textContent = "";
			index = (index + 1) % items.length;
			setTimeout(typeNext, 300);
		});
	};

	typeNext();
}

function typeTextInElement(el, fullText, avgSpeedMs, endBlinkMs, onComplete) {
	el.classList.add("active");

	const textSpan = document.createElement("span");
	textSpan.className = "typingText";
	const cursorSpan = document.createElement("span");
	cursorSpan.className = "typingCursor";

	el.innerHTML = "";
	el.appendChild(textSpan);
	el.appendChild(cursorSpan);

	let i = 0;
	const preBlinkMs = 1200; // blink ~2 times at start

	// Pre-typing blink
	cursorSpan.classList.add("is-blinking");

	setTimeout(() => {
		// Hide cursor during typing
		cursorSpan.classList.remove("is-blinking");
		cursorSpan.classList.add("is-hidden");

		const measureSpan = document.createElement("span");
		measureSpan.style.position = "absolute";
		measureSpan.style.visibility = "hidden";
		measureSpan.style.whiteSpace = "pre-wrap";
		measureSpan.style.wordBreak = "keep-all";
		measureSpan.style.width = "100%";
		el.appendChild(measureSpan);

		let committedText = "";
		let inWord = false;
		let wordEndIndex = 0;
		let lettersInWordTyped = 0;
		let currentWord = "";

		const findWordEnd = (start) => {
			let j = start;
			while (j < fullText.length) {
				const ch = fullText.charAt(j);
				if (ch === " " || ch === "\n") break;
				j += 1;
			}
			return j;
		};

		const consumeWhitespace = () => {
			let changed = false;
			while (i < fullText.length) {
				const ch = fullText.charAt(i);
				if (ch === " " || ch === "\n") {
					committedText += ch;
					i += 1;
					changed = true;
				} else {
					break;
				}
			}
			if (changed) textSpan.textContent = committedText;
		};

		const startWord = () => {
			wordEndIndex = findWordEnd(i);
			currentWord = fullText.slice(i, wordEndIndex);
			measureSpan.textContent = committedText;
			const baseH = measureSpan.offsetHeight;
			measureSpan.textContent = committedText + currentWord;
			const withWordH = measureSpan.offsetHeight;
			if (withWordH > baseH && committedText && committedText.charAt(committedText.length - 1) !== "\n") {
				committedText += "\n";
			}
			lettersInWordTyped = 0;
			inWord = true;
		};

		const step = () => {
			if (i >= fullText.length && !inWord) {
				cursorSpan.classList.remove("is-hidden");
				cursorSpan.classList.add("is-blinking");
				setTimeout(() => {
					if (typeof onComplete === "function") onComplete();
				}, endBlinkMs);
				return;
			}

			if (!inWord) {
				consumeWhitespace();
				if (i >= fullText.length) {
					setTimeout(step, 0);
					return;
				}
				startWord();
			}

			if (inWord) {
				lettersInWordTyped += 1;
				textSpan.textContent = committedText + currentWord.slice(0, lettersInWordTyped);
				if (lettersInWordTyped >= currentWord.length) {
					committedText += currentWord;
					i = wordEndIndex;
					inWord = false;
				}
			}

			const jitter = Math.floor(Math.random() * 40) - 20;
			const delay = Math.max(15, avgSpeedMs + jitter);
			setTimeout(step, delay);
		};

		step();
	}, preBlinkMs);
}
